import React, { useState, useEffect } from "react";
import { Typography, Grid, Container } from "@mui/material";
import api from "../../globals/axios";
import { useParams } from "react-router-dom";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import {
  CustomTitle,
  CustomLabel,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import ViewIcon from "../../assets/Icon/ViewIcon.png";
import DownLoadIcon from "../../assets/Icon/DownLoadIcon.png";
import LoaderContainer from "../../components/LoaderContainer";
import SingleCustomCard from "../../components/Custom/SingleCustomCard";

export default function ViewHarvestNew() {
  const { t } = useTranslation();
  const { harvestId } = useParams();
  const [loading, setLoading] = useState(true);
  const [tokenData, setTokenData] = useState({
    crop: [],
    harvest_date: "",
    quantity: "",
    sales: [],
  });

  const loadNFT = async () => {
    let res = await api.get(`/farmer/harvests/${harvestId}`);
    const data = res.data;
    setLoading(false);
    setTokenData(data);
  };

  useEffect(() => {
    loadNFT();
  }, [harvestId]);
  const labelValuePairs = [
    { label: t("Crop Name"), value: tokenData?.crop?.crop_type ?? "" },
    { label: t("Harvest Date"), value: tokenData?.harvest_date ?? "" },
    { label: t("Qauntity"), value: tokenData?.quantity ?? "" },
  ];

  return (
    <>
      <CustomAppBar title="View Harvest" />

      <LoaderContainer loading={loading}>
        <Container maxWidth="xs" sx={{ padding: "16px" }}>
          <CustomTitle>{t("Harvest View")}</CustomTitle>
          <Grid
            container
            direction="column"
            style={{ marginTop: "10px" }}
            spacing={0}
          >
            {labelValuePairs.map((pair) => (
              <Grid item container key={pair.label}>
                <Grid item xs={5}>
                  <CustomLabel>{pair.label}</CustomLabel>
                </Grid>
                <Grid item xs={1}>
                  <CustomLabel>:</CustomLabel>
                </Grid>

                <Grid item xs={6}>
                  <CustomValue>{pair.value}</CustomValue>
                </Grid>
              </Grid>
            ))}

            <Grid item xs={12} sx={{ marginTop: "20px" }}>
              <CustomLabel>{t("Weigh Bridge Receipt ")}:</CustomLabel>
            </Grid>
            <Grid
              container
              item
              xs={9}
              alignItems="center"
              // sx={{ marginTop: "-14px" }}
            >
              <Grid item xs={9}>
                <CustomValue>
                  {tokenData.weigh_bridge_receipt ? (
                    <Typography style={{ fontSize: "12px" }}>
                      {
                        tokenData.weigh_bridge_receipt
                          .split("/")
                          .pop()
                          .split("?")[0]
                      }
                    </Typography>
                  ) : (
                    <Typography style={{ fontSize: "12px" }}>
                      {" "}
                      {t("No File available")}
                    </Typography>
                  )}
                </CustomValue>
              </Grid>
              {tokenData.weigh_bridge_receipt && (
                <>
                  <Grid item xs={1} columnGap={2} sx={{ marginTop: "10px" }}>
                    <a href={tokenData.weigh_bridge_receipt} target="_blank" rel="noreferrer">
                      <img src={ViewIcon} alt="View Icon" />
                    </a>
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    sx={{ marginLeft: "20px", marginTop: "10px" }}
                    // onClick={handleDownload}
                  >
                    <img src={DownLoadIcon} alt="Download Icon" />
                  </Grid>
                </>
              )}
            </Grid>

            {/* Card Section for Crop Information */}
            {tokenData.sales && (
              <Grid
                item
                style={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  padding: "5px",
                }}
              >
                <CustomTitle>{t("Sales")}</CustomTitle>
                <SingleCustomCard
                  data={[
                    { label: "Sold To", value: tokenData.sales[0]?.sold_to },
                    { label: "Quantity", value: tokenData.sales[0]?.quantity },
                  ]}
                />
              </Grid>
            )}
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}
